import React, { FC, useMemo } from 'react';
import FinanceElementsTypes from '../../../../../../../../common/enum/FinanceElementsTypes';
import { Box, useTheme } from '@material-ui/core';
import InterestRateContainer from './interestRate/InterestRateContainer';
import ComparisonRateContainer from './comparisonRate/ComparisonRateContainer';
import ChosenRateContainer from './chosenRate/ChosenRateContainer';
import ChosenTermContainer from './chosenTerm/ChosenTermContainer';
import TermContainer from './termContainer/TermContainer';
import informativeSectionContainerStyles from './informativeSectionContainerStyles';
import TermInYearsContainer from './termInYears/TermInYearsContainer';
import DepositPercentageContainer from './depositPercentage/DepositPercentageContainer';
import MonthlyInterestContainer from './monthlyInterest/MonthlyInterestContainer';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import { financeFormInputVar } from '../../../../../../gqlCommon/graphql/cache';
import FinanceDepositContainer from './financeDeposit/FinanceDepositContainer';
import { useReactiveVar } from '@apollo/client';

const InformativeSectionContainer: FC = () => {
  const styles = informativeSectionContainerStyles();
  const financeFormInput = useReactiveVar(financeFormInputVar);
  const {
    spc: {
      customise: { availableFinanceElements },
    },
  } = useTheme<ISpcTheme>();

  const MappedFinanceElements: Partial<Record<FinanceElementsTypes, JSX.Element>> = useMemo(
    () => ({
      [FinanceElementsTypes.INTEREST_RATE]: <InterestRateContainer />,
      [FinanceElementsTypes.COMPARISON_RATE]: <ComparisonRateContainer />,
      [FinanceElementsTypes.CHOSEN_RATE]: <ChosenRateContainer />,
      [FinanceElementsTypes.CHOSEN_TERM]: <ChosenTermContainer />,
      [FinanceElementsTypes.TERM]: <TermContainer />,
      [FinanceElementsTypes.TERM_IN_YEARS]: <TermInYearsContainer />,
      [FinanceElementsTypes.DEPOSIT_PERCENTAGE]: <DepositPercentageContainer />,
      [FinanceElementsTypes.MONTHLY_INTEREST]: <MonthlyInterestContainer />,
      [FinanceElementsTypes.FINANCE_DEPOSIT]: <FinanceDepositContainer />,
    }),
    [financeFormInput],
  );

  return (
    <Box display="flex" className={styles.container}>
      {(availableFinanceElements || [FinanceElementsTypes.INTEREST_RATE]).map(element => (
        <Box className={styles.informativeItem} key={element}>
          {MappedFinanceElements[element]}
        </Box>
      ))}
    </Box>
  );
};

export default InformativeSectionContainer;
